export default function ThreedotIcon({ fill = "#716E7A" }) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.0013" cy="9.99992" r="1.66667" transform="rotate(90 10.0013 9.99992)" fill={fill} />
            <circle cx="15.8333" cy="9.99998" r="1.66667" transform="rotate(90 15.8333 9.99998)" fill={fill} />
            <ellipse cx="4.16536" cy="9.99992" rx="1.66667" ry="1.66667" transform="rotate(90 4.16536 9.99992)" fill={fill} />
        </svg>
    );
}
